<template>
  <!-- eslint-disable vue/no-v-html -->
  <div v-html="displayedText" />
</template>

<script>

export const STOP_DELIMITER = '<STOP>'
export const STOP_DELIMITER_STREAMING = '&lt;STOP&gt;'

export default {
  props: {
    text: {
      type: String,
      required: true
    },
    interval: {
      type: Number,
      default: 20
    },
    steps: {
      type: Number,
      default: 1
    }
  },
  data () {
    return {
      displayedText: '',
      currentIndex: 0,
      fullText: this.text
    }
  },
  watch: {
    text (newText) {
      this.fullText = newText
    }
  },
  created () {

  },
  mounted () {
    if (!this.validateStopDelimiterPresence()) {
      this.startTyping()
    }
  },
  beforeDestroy () {
    clearInterval(this.typingInterval)
  },
  methods: {
    validateStopDelimiterPresence () {
      if (this.fullText.endsWith(STOP_DELIMITER_STREAMING)) {
        clearInterval(this.typingInterval)
        this.displayedText = this.fullText.slice(0, -STOP_DELIMITER_STREAMING.length)
        return true
      }
      return false
    },
    intervalHandler () {
      if (this.validateStopDelimiterPresence()) {
        return
      }

      if (this.currentIndex < this.fullText.length) {
        this.currentIndex += this.steps
        this.displayedText = this.fullText.slice(0, this.currentIndex)
        if (this.currentIndex >= this.fullText.length) {
          this.currentIndex = this.fullText.length
        }
      }
    },
    startTyping () {
      this.typingInterval = setInterval(() => {
        this.intervalHandler()
      }, this.interval)
    }
  }
}
</script>
